var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "follow-wrapper bj" },
    [
      _c("Filtersearch", {
        ref: "Filtersearchref",
        attrs: { list: _vm.Filtersearchlist, fromdata: _vm.formData },
        on: {
          Refresh: _vm.Refresh,
          search: _vm.search,
          selectChange: _vm.cityChange,
        },
        scopedSlots: _vm._u([
          {
            key: "right",
            fn: function () {
              return [
                _c(
                  "el-button",
                  {
                    attrs: {
                      disabled: !_vm.tableData.length || _vm.disabledExport,
                      type: "warning",
                      icon: "el-icon-download",
                    },
                    on: { click: _vm.onHandleExport },
                  },
                  [_vm._v("导出")]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "div",
        { staticClass: "auto-table-flex" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              key: _vm.tableKey,
              ref: "table",
              attrs: {
                data: _vm.tableData,
                height: "100%",
                border: true,
                "header-cell-style": {
                  color: "#333333",
                  background: "#EFF6FF",
                },
                "tooltip-effect": "dark",
              },
              on: { "header-dragend": _vm.handleHeaderDragEnd },
            },
            [
              _vm._l(_vm.columns, function (column) {
                return _c("el-table-column", {
                  key: column.prop,
                  attrs: {
                    prop: column.prop,
                    label: column.label,
                    "show-overflow-tooltip": column.showoverflowtooltip,
                    align: "center",
                    fixed: column.fixed,
                    "min-width": column.minWidth,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            column.prop == "goods_name"
                              ? _c("span", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getGoodsName(scope.row.aftersale)
                                      )
                                  ),
                                ])
                              : column.prop == "reason_name"
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.getReason(scope.row.aftersale))
                                  ),
                                ])
                              : column.prop == "sku_code"
                              ? _c("span", [_vm._v(_vm._s(scope.row.sku_code))])
                              : column.prop == "supplier_create_at"
                              ? _c("span", [
                                  _vm._v(_vm._s(scope.row.supplier_create_at)),
                                ])
                              : column.prop == "star_customer_grade_detail"
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(scope.row.star_customer_grade_detail)
                                  ),
                                ])
                              : column.prop == "member_name"
                              ? _c("span", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getMemberName(scope.row.aftersale)
                                      )
                                  ),
                                ])
                              : column.prop == "member_mobile"
                              ? _c("span", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getMemberMobile(scope.row.aftersale)
                                      )
                                  ),
                                ])
                              : column.prop == "logistics_name"
                              ? _c("span", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getLogisticsName(
                                          scope.row.aftersale
                                        )
                                      )
                                  ),
                                ])
                              : column.prop == "delivery_name"
                              ? _c("span", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getDeliveryName(scope.row.aftersale)
                                      )
                                  ),
                                ])
                              : column.prop == "supplier_name"
                              ? _c("span", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getSupplierName(scope.row.aftersale)
                                      )
                                  ),
                                ])
                              : column.prop == "buyer_name"
                              ? _c("span", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getSupplierBuyerName(
                                          scope.row.aftersale
                                        )
                                      )
                                  ),
                                ])
                              : column.prop == "logistic_business_name"
                              ? _c("span", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        scope.row.logistic_business_name || "-"
                                      )
                                  ),
                                ])
                              : column.prop == "create_time"
                              ? _c("span", [
                                  _vm._v(
                                    " " + _vm._s(scope.row.create_time || "-")
                                  ),
                                ])
                              : column.prop == "as_no"
                              ? _c("span", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        (scope.row.aftersale &&
                                          scope.row.aftersale.as_no) ||
                                          "-"
                                      )
                                  ),
                                ])
                              : column.prop == "order_no"
                              ? _c("span", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        (scope.row.aftersale &&
                                          scope.row.aftersale.order_no) ||
                                          "-"
                                      )
                                  ),
                                ])
                              : column.prop == "cate_name"
                              ? _c("span", [
                                  _vm._v(" " + _vm._s(scope.row.cate_name)),
                                ])
                              : column.prop == "status_name"
                              ? _c(
                                  "span",
                                  [
                                    scope.row.status ===
                                    _vm.AUDIT_STATUS_ENUM.ing.value
                                      ? _c(
                                          "el-tag",
                                          { attrs: { type: "warning" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.AUDIT_STATUS_ENUM.ing.label
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    scope.row.status ===
                                    _vm.AUDIT_STATUS_ENUM.return.value
                                      ? _c(
                                          "el-tag",
                                          { attrs: { type: "success" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.AUDIT_STATUS_ENUM.return
                                                  .label
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    scope.row.status ===
                                    _vm.AUDIT_STATUS_ENUM.reject.value
                                      ? _c(
                                          "el-tag",
                                          { attrs: { type: "danger" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.AUDIT_STATUS_ENUM.reject
                                                  .label
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              : _c("span", [
                                  _vm._v(" " + _vm._s(scope.row[column.prop])),
                                ]),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                })
              }),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  "min-width": "150",
                  align: "center",
                  fixed: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status === _vm.AUDIT_STATUS_ENUM.ing.value
                          ? _c(
                              "router-link",
                              {
                                staticClass: "main-color pointer text-none",
                                attrs: {
                                  to: {
                                    name: "newAfterCheck",
                                    query: {
                                      id: scope.row.as_id,
                                      state: scope.row.state,
                                    },
                                  },
                                },
                              },
                              [_vm._v("去审批 ")]
                            )
                          : _c(
                              "router-link",
                              {
                                staticClass: "main-color pointer text-none",
                                attrs: {
                                  to: {
                                    name: "newAfterDetail",
                                    query: {
                                      id: scope.row.as_id,
                                      state: scope.row.state,
                                    },
                                  },
                                },
                              },
                              [_vm._v("查看详情 ")]
                            ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "fy" },
        [
          _c("el-pagination", {
            attrs: {
              type: "primary",
              background: "",
              "current-page": _vm.formData.page,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.formData.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.onHandleSizeChange,
              "current-change": _vm.onHandleCurrentChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }